<template>
  <div class="login_card">
    <div class="user_card"  v-if="isLogin">
        <div class="content">
            <div class="user_lv">
                <img class="lv_img" :src="img_url + userInfo.vip_img"><span class="lv_font">LV {{ userInfo.user_growth }} 会员</span><div class="fgx"></div>
                <span style="color: red;">会员编号：{{ userInfo.id }}</span><div class="fgx"></div>
                <span class="lv_font">会员等级额外:+{{ userInfo.exchange_jiacheng }}%</span>
            </div>
            <div class="user_point">
                <div class="point_item">
                    <span>账户可用储值</span>
                    <span> {{ setStores(userStore.available ? userStore.available : 0) }}</span>
                </div>
                <div class="point_item">
                    <span>账户可用积分</span>
                    <span> {{ setStores(userPoint.available ? userPoint.available : 0) }}</span>
                </div>
                <div class="point_item">
                    <span>账户成长值</span>
                    <span> 
                        {{ setStores(userGrowth.available ? userGrowth.available : 0) }}
                        <font color="red" v-if="false"> + 临时 :{{setStores(0)}}</font>
                    </span>
                </div>
                <div class="point_item">
                    <span>账户可用转区点 </span>
                    <span> {{ setStores(getTransfer.available ? getTransfer.available : 0) }}</span>
                </div>
            </div>
            <div class="btn_flex">
                <div @click="toWallet(1)" class="btn_item">自助充值</div>
                <router-link to="/member" class="btn_item">用户签到</router-link>
                <router-link to="/helps" class="btn_item">服务中心</router-link>
            </div>
            <div class="end_time">到期时间：{{ userInfo.growth_expires_time ? userInfo.growth_expires_time : '---' }}</div>
        </div>
        <!-- 背景 -->
        <img class="card_bg" :src="img_url + userInfo.vip_kp_img">
    </div>
    <div class="unlogin_card"  v-else>
        <div class="btn_hover login_btn" @click="LoginOne">注册/登录</div>
        <img class="unlogin_img" src="/banner/img/login.jpg">
    </div>
    <img v-if="type == 1" class="czfl_img" src="/banner/img/czfl.gif" >
    <img v-if="type == 2" class="czfl_img" src="/banner/img/huigui4.gif" >
    <Login ref="login" @closeLogin="closeLogin"></Login>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Login from "../components/Login.vue";
export default {
    name: 'UserCard',
    components:{
        Login
    },
    data() {
        return {
            
        }
    },
    props:['type'],
    computed:{
        ...mapState([
            'material',
            'getClient',
            'isLogin',
            'unLogin',
            'userInfo',
            'userGrowth',
            'userStore',
            'userPoint',
            'getTransfer',
        ])
    },
    methods:{
        LoginOne(){
            this.$refs.login.open()
            $("body").parent().css("overflow-y","hidden")
            $("body").parent().css("overflow-x","hidden")
        },
        closeLogin(){
            $("body").parent().css("overflow-y","auto")
            $("body").parent().css("overflow-x","auto")
        },
        setStores(val) {
            return Math.round(val)
        },
        toWallet(type){
            this.cz_id = type
            this.$router.push({
                path:'/member/wallet'
            })
            this.$czc( 'PC首页储值入口', '点击', '访问平台充值')
        },
    }
}
</script>

<style scoped>
.login_card{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 16px 269px;
    background: #f5f5f5;
}
.czfl_img{
    width: 800px;
}
.unlogin_card{
    position: relative;
    margin-right: 10px;
}
.unlogin_img{
    width: 530px;
}
.login_btn{
    position: absolute;
    left: 50%;
    bottom: 20%;
    transform: translateX(-50%);
    background-color: #af1f06;
    color: #fff;
    border: 1px solid #fffc86;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    border-radius: 4px;
}
.user_card{
    position: relative;
    width: 530px;
    height: 225px;
    padding: 20px;
    margin-right: 10px;
}
.content{
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 2;
    width: 100%;
    height: 100%;
}
.card_bg{
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1;
    border-radius: 4px;
    width: 530px;
}
.user_lv{
    font-size: 16px;
    font-weight: bolder;
    display: flex;
    align-items: center;
}
.lv_img{
    width: 50px;
}
.lv_font{
    color: #9c4100;
    margin-left: 5px;
}
.fgx{
    height: 15px;
    margin: 0 5px;
    width: 1px;
    background: #9c4100;
}
.user_point{
    display: flex;
    flex-direction: column;
    margin-top: 10px;
}
.point_item{
    width: 45%;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #9c4100;
}
.btn_flex{
    display: flex;
    margin-top: 20px;
}
.end_time{
    font-size: 16px;
    color: #9c4100;
    margin-top: 5px;
}
.btn_item{
    padding: 4px 8px;
    border-radius: 3px;
    font-size: .8rem;
    color: #dc3545;
    border:1px solid #dc3545;
    cursor: pointer;
    transition: all .5s;
    margin-right: 5px;
    text-decoration: none;
}
.btn_item:hover{
    background: #dc3545;
    color: #fff;
    transition: all .5s;
}
</style>